// extracted by mini-css-extract-plugin
module.exports = {"transactionStatusHolder":"transaction-status-label_transactionStatusHolder__2Mp4L","textStyle":"transaction-status-label_textStyle__13EoZ"};